<div class="relative flex min-h-screen">
    <!-- ================= DESKTOP SIDEBAR ================= -->
    <aside
        class="fixed top-0 bottom-0 left-0 z-50 hidden h-screen transition-all duration-300 md:block"
        [ngClass]="{
            'w-18': isSidebarCollapsed,
            'w-60': !isSidebarCollapsed,
        }">
        <app-sidebar-easy-mode [isCollapsed]="isSidebarCollapsed">
        </app-sidebar-easy-mode>
    </aside>

    <!-- Sidebar spacer to reserve width in document flow -->
    <div
        class="hidden h-screen shrink-0 transition-all duration-300 md:block"
        [ngClass]="{
            'w-18': isSidebarCollapsed,
            'w-60': !isSidebarCollapsed,
        }"></div>

    <!-- ================= MOBILE SIDEBAR ================= -->
    @if (isMobileSidebarOpen) {
        <div class="fixed inset-0 z-50 md:hidden">
            <!-- Overlay -->
            <div
                class="absolute inset-0 bg-black/20 backdrop-blur-[2px]"
                (click)="closeMobileSidebar()"></div>

            <!-- Drawer -->
            <div
                class="absolute top-0 left-0 h-full w-62 bg-white shadow-2xl transition-all duration-300">
                <button
                    (click)="closeMobileSidebar()"
                    class="absolute top-3 right-3 z-50 flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 transition hover:bg-gray-200">
                    <i class="pi pi-times text-sm text-gray-700"></i>
                </button>

                <app-sidebar-easy-mode
                    [isCollapsed]="false"></app-sidebar-easy-mode>
            </div>
        </div>
    }

    <!-- ================= MAIN CONTENT ================= -->
    <section
        class="bg-color-main flex min-h-screen min-w-0 flex-1 flex-col overflow-hidden">
        <app-easy-header-default
            (sidebarToggle)="toggleSidebar()"
            class="sticky top-0 z-40">
        </app-easy-header-default>

        <!-- Bottom nav spacing -->
        <main class="flex-1 p-4 pb-24 md:pb-4">
            <ng-content></ng-content>
        </main>

        <!-- ================= MINIMAL MOBILE NAV ================= -->
        <div class="fixed right-3 bottom-2 left-3 z-40 md:hidden">
            <app-easy-mobile-nav (menuClick)="toggleSidebar()">
            </app-easy-mobile-nav>
        </div>
    </section>
</div>
